import { render, staticRenderFns } from "./PaymentRemit.vue?vue&type=template&id=1037441a&scoped=true"
import script from "./PaymentRemit.vue?vue&type=script&lang=js"
export * from "./PaymentRemit.vue?vue&type=script&lang=js"
import style0 from "./PaymentRemit.vue?vue&type=style&index=0&id=1037441a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_babel-core@7.0.0-bridge.0_@babel+core@7.28._1eb1b9dda9fe6d233009820956254809/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1037441a",
  null
  
)

export default component.exports